module.exports = __webpack_public_path__ + "assets/img/title-8ae7d6d4.png";